<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>

    <!-- 添加 -->
    <div class="content content1 " v-if="addType">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p :class="headID==1?'select':''" @click="headSub('1')">练习</p>
          <p :class="headID==2?'select':''" @click="headSub('2')">模拟卷</p>
        </div>
        <div class="organiza-form">
          <form v-if='headID==1'>
            <div class="form-txt">
              <p class="title">练习名称：</p>
              <div class="txt">
                <input type="text" placeholder="请输入练习名称" v-model="ExerSet.name">
              </div>
            </div>
            <div class="form-txt">
              <p class="title">封面：</p>
              <div class="txt">
                <div class="img" @mouseenter="imgShow('ExerSet')" @mouseleave="imgHide('ExerSet')" v-if="ExerSet.img">
                  <img :src="'https://pic.bi-rong.com/'+ExerSet.img" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="el-icon-delete" @click="imgRemove('ExerSet')"></i>
                  </div>
                </div>
                <div class="upload">
                  <el-upload
                    :action="url+'/ent/Upload/uploadFile'"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="'https://pic.bi-rong.com/'+ExerSet.img" alt="">
                  </el-dialog>
                </div>
              </div>
            </div>
            <div class="form-txt">
              <p class="title">单题时长：</p>
              <div class="txt" style="font-size: 12px;">
                <input type="number" placeholder="请输入时长" v-model="ExerSet.contime">秒
              </div>
            </div>
            <div class="examList">
              <div class="form-txt" v-for="(item,index) in ExerSet.chapter" v-bind:key="index">
                <p class="title">章节{{(index+1)}}：</p>
                <div class="txt chapter">
                  <div class="chapter-title">
                    <p>名称：</p>
                    <input type="text" placeholder="" v-model="item.name">
                  </div>
                  <div class="chapter-topicList">
                    <div class="chapter-topic" v-for="(ele,num) in item.topic_set" v-bind:key="num">
                      <div class="chapter-topic1">
                        <p>题型{{(num+1)}}：</p>
                        <select v-model="ele.type">
                          <option value="">请选择题型</option>
                          <option :value="item.id" v-for="item in singleTopic" v-bind:key="item.id">{{item.title}}</option>
                        </select>
                      </div>  
                      <div class="chapter-topic2">
                        <p>数量：</p>
                        <input type="text" placeholder="" v-model="ele.num">
                      </div>
                      <div class="btnBox" v-if="num>0">
                        <button class="btn btn-remove" @click.prevent="removeTopic(num,'set',item)">删除</button>
                      </div>  
                      <span class="msg-txt" v-if="ele.type == 4">单个案例素材下必须有10道小题，小于或大于10道题则无法提交</span>
                    </div>
                    <button class="btn btn-add" @click.prevent="addTopic(item,'set')">添加题型</button>
                    <!-- <button class="btn btn-add" @click.prevent="removeTopic(item,'set')">删除题型</button> -->
                  </div>
                </div>
              </div>
            </div>
          </form>
          <form v-else>
            <div class="form-txt">
              <p class="title">模拟卷名称：</p>
              <div class="txt">
                <input type="text" placeholder="请输入模拟卷名称" v-model="TestSet.name">
                <!-- <span>10/20</span> -->
              </div>
            </div>
            <div class="form-txt">
              <p class="title">封面：</p>
              <div class="txt">
                <div class="img" @mouseenter="imgShow('ExerSet')" @mouseleave="imgHide('ExerSet')" v-if="TestSet.img">
                  <img :src="'https://pic.bi-rong.com/'+TestSet.img" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="el-icon-delete" @click="imgRemove('ExerSet')"></i>
                  </div>
                </div>
                <div class="upload">
                  <el-upload
                    :action="url+'/ent/Upload/uploadFile'"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                    >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <!-- <el-dialog >
                    <img width="100%" :src="'https://pic.bi-rong.com/'+TestSet.img" alt="">
                  </el-dialog> -->
                </div>
              </div>
            </div>
            <div class="form-txt">
              <p class="title">模拟卷数量：</p>
              <div class="txt">
                <select v-model="TestSet.num">
                  <option value="">请选择数量</option>
                  <option :value="item" v-for="item in 10" v-bind:key="item">{{item}}</option>
                </select>
              </div>
            </div>
            <div class="form-txt">
              <p class="title">考试总分：</p>
              <div class="txt">
                <input type="number" placeholder="请输入考试总分" v-model="TestSet.score">
                <span>分</span>
              </div>
            </div>
            <div class="form-txt">
              <p class="title">及格分数：</p>
              <div class="txt">
                <input type="number" placeholder="请输入及格分数" v-model="TestSet.pass">
                <span>分</span>
              </div>
            </div>
            <div class="form-txt">
              <p class="title">考试时长：</p>
              <div class="txt">
                <input type="number" placeholder="请输入考试时长" v-model="TestSet.contime">
                <span>分钟</span>
              </div>
            </div>


            <div class="examList">
              <div class="txt chapter">
                <div class="chapter-topicList">
                  <div class="chapter-topic" v-for="(item,index) in TestSet.topic_set" v-bind:key="index">
                    <div class="chapter-topic1">
                      <p>题型{{(index+1)}}：</p>
                      <select v-model="item.type">
                        <option value="">请选择题型</option>
                        <option :value="item.id" v-for="item in singleTopic" v-bind:key="item.id">{{item.title}}</option>
                      </select>
                      <span class="msg-txt" v-if="item.type == 4">单个案例素材下必须有10道小题，小于或大于10道题则无法提交</span>
                    </div>  
                    <div class="chapter-topic2">
                      <p>数量：</p>
                      <input type="number" placeholder="" v-model="item.num">
                    </div>     
                    <div class="chapter-topic2">
                      <p>分数：</p>
                      <input type="number" placeholder="" v-model="item.score">
                      <p>分</p>
                    </div>
                    <div class="btnBox" v-if="index>0">
                      <button class="btn btn-remove" @click.prevent="removeTopic(item,'test',index)">删除</button>
                    </div>                 
                  </div>
                  <button class="btn btn-add" @click.prevent="addTopic('test')">添加题型</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="btnBox">
        <button class="btn btn-sub" @click="topicSub">提交{{headID==1?'练习':'模拟卷'}}</button>
        <button class="btn btn-close" @click="topicHide">取消</button>
      </div>
    </div>

    <!-- 列表 -->
    <div class="content content2">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>证书名称：</p>
          <input type="text" placeholder="请输入要搜索的证书名称" v-model="obj.title">
        </div>
        <div class="search-item">
          <p>发布状态：</p>
          <select v-model="obj.status">
            <option :value="item.id" v-for="item in statusList" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>证书列表</p>
          <div class="btnBox" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('1-2-1')>-1">
            <button class="btn btn-add" @click="addShow">添加证书</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="item.id">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.level">{{item.level}}</p>
              <p :title="item.num">{{item.num}}</p>
              <p :title="item.topic_num">{{item.topic_num}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p>
                <span style="color:#4C7EFB" @click="lookTopic(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('1-2-2')>-1">查看题库</span>
                <span style="color:#4C7EFB" @click="lookStudent(item.id)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('1-2-3')>-1">查看学员</span>
              </p>
              <p>
                <span style="color:#4C7EFB" @click="configShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('1-2-4')>-1">配置</span>
                <span style="color:#FF7543" @click="editShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('1-2-5')>-1">编辑</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="obj.rows"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 详情 -->
    <div class="content content3 hide">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>考试管理/查看详情</p>
        </div>
        <div class="organiza-form">
          <form>
            <div class="form-txt">
              <p class="title">考试名称：职业培训师三级【理论模拟考三】</p>
            </div>
            <div class="form-txt form-txt2">
              <p class="title">考试说明：职业培训师三级理论模拟考试，总共50道题，每道题2分，总分100分，及格为60分。</p>
            </div>
            <div class="form-txt">
              <p class="title">考试总分：100分</p>
            </div>
            <div class="form-txt">
              <p class="title">及格分数：60分</p>
            </div>
            <div class="form-txt">
              <p class="title">考试时长：40分钟</p>
            </div>
            <div class="form-txt">
              <p class="title">当前状态：开启</p>
            </div>
          </form>
        </div>
      </div>
      <div class="btnBox">
        <button class="btn btn-close" @click="showType='list';">返回</button>
      </div>
    </div>

    <!-- 查看题库 -->
    <div class="content content4 hide">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>题目/题干ID：</p>
          <input type="text" placeholder="请输入要搜索的考试名称">
        </div>
        <div class="search-item">
          <p>题型：</p>
          <select>
            <option :value="item.id" v-for="item in singleTopic" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="search-item">
          <p>当前状态：</p>
          <select>
            <!-- <option :value="item.id" v-for="item in stateList" v-bind:key="item.id">{{item.title}}</option> -->
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search">搜索</button>
          <button class="btn btn-reset">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>考试管理</p>
          <div class="btnBox">
            <button class="btn btn-batch1" @click="">批量删除</button>
            <button class="btn btn-batch2" @click="">单题导入</button>
            <button class="btn btn-batch3" @click="">批量导入</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in topicTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in topicData" v-bind:key="(index+1)">
              <p>
                <label for="">
                  <input type="checkbox" name="state" v-model="item.check">
                </label>
              </p>
              <p :title="(index+1)">{{(index+1)}}</p>
              <p :title="item.examID">{{item.examID}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.type==1?'单选题':item.type==2?'多选题':'判断题'">{{item.type==1?'单选题':item.type==2?'多选题':'判断题'}}</p>
              <p :title="item.answer">{{item.answer}}</p>
              <p :title="item.analysis">{{item.analysis}}</p>
              <p :title="item.num">{{item.num}}</p>
              <p :title="item.state==0?'未开启':'开启'">{{item.state==0?'未开启':'开启'}}</p>
              <p style="color:#4C7EFB;" @click="topicSub">详情</p>
              <p style="color:#FF7543;">编辑</p>
              <p style="color:#FF5156;">删除</p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="100"
              layout="prev, pager, next, jumper"
              :total="1000">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 删除提示框 -->
    <div class="msgBox removeBox hide">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认删除此项考试数据吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="">删除</button>
          <button class="btn btn-close" @click="">取消</button>
        </div>
      </div>
    </div>

    <!-- 确认提示框 -->
    <div class="msgBox removeBox " v-if="successType">
      <div class="contv">
        <p class="title">提交成功！</p>
        <p class="txt">是否继续配置</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="successType=false;">是</button>
          <button class="btn btn-close" @click="successHide">否</button>
        </div>
      </div>
    </div>

    <!-- 添加证书 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加证书':'编辑证书'}}</p>
        <form>
          <div class="write-txt">
            <p>证书名称：</p>
            <input type="text" placeholder="请填写证书名称" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>证书类型：</p>
            <select v-model="addObj.csid">
              <option value="" disabled>请选择类型</option>
              <option :value="item.id" v-for="item in CertList" v-bind:key="item.id">{{item.name}}</option>
            </select>
          </div>
          <div class="write-txt">
            <p>证书级别：</p>
            <select v-model="addObj.level">
              <option value="" disabled>请选择级别</option>
              <option :value="item" v-for="item in 10" v-bind:key="item">{{item}}</option>
            </select>
          </div>
          <div class="write-txt">
            <p>章节数量：</p>
            <select v-model="addObj.num">
              <option value="" disabled>请选择章节数量</option>
              <option :value="item" v-for="item in 100" v-bind:key="item">{{item}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getSelectCertList,saveCert,getCertList,getSelectCertTypeList,updateCertStatus,saveExerSet,saveTestSet,getExerSet,getTestSet,getOpenTopicSetList } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      statusList:[
        {id:9,title:'全部'},
        {id:1,title:'发布'},
        {id:0,title:'未发布'},
      ],
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'证书ID'},
        {id:3,title:'证书名称'},
        {id:4,title:'证书级别'},
        {id:5,title:'章节数量'},
        {id:6,title:'已上传题目数量'},
        {id:7,title:'创建时间'},
        {id:8,title:'发布状态'},
      ],
      dataList:[],
      removeType:false,
      examState:[
        {id:1,title:'开启'},
        {id:2,title:'未开启'},
      ],
      topicList:[
        {type:'',num:0}
      ],
      topicType:[
        {id:1,title:'单选题'},
        {id:2,title:'多选题'},
        {id:3,title:'判断题'},
      ],
      showType:'',
      topicTitle:[
        {id:1,title:''},
        {id:2,title:'序号'},
        {id:3,title:'题目ID'},
        {id:4,title:'题干'},
        {id:5,title:'题型'},
        {id:6,title:'答案'},
        {id:7,title:'解析'},
        {id:8,title:'分值'},
        {id:9,title:'状态'},
      ],
      topicData:[],
      headID:1,
      addType:false,
      obj:{
        page:1,
        rows:10,
        status:9
      },
      addObj:{
        csid:'',
        level:'',
        name:'',
        num:''
      },
      singleTopic:[],
      totalPage:0,
      CertList:[],
      ExerSet:{
        cert_id:'',
        name:'',
        img:'',
        chapter:[
          
        ]
      },
      TestSet:{
        cert_id:'',
        name:'',
        img:'',
        num:'',
        score:'',
        pass:'',
        contime:'',
        topic_set:[
          {type:'',score:'',num:''},
        ],
      },
      imgType:false,
      dialogVisible:false,
      textNum:0,
      configID:'',
      chapterNum:0,
      TestSetType:false,
      ExerSetType:false,
      successType:false,
      userData:{
        authority:[],
      },
      url:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var that = this;
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.url = this.$refs.navBox.url;
    this.getList();
    getSelectCertTypeList(this.token).then((res)=>{
      var data = res.data;
      if(data.code == 200){
        that.CertList = data.data;
      } else {
        that.$message(data.msg);
      }
    });
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    handleRemove(file, fileList) {
      console.log(file, fileList,'remove');
      if(this.headID == 1){
        this.ExerSet.img = '';
      } else {
        this.TestSet.img = '';
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList){
      if(this.headID == 1){
        this.ExerSet.img = response.data.src;
      } else {
        this.TestSet.img = response.data.src;
      };
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      if(this.headID == 1){
        this.ExerSet.img = '';
      } else {
        this.TestSet.img = '';
      };
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
        status:9
      };
      this.dataList = [];
      this.headID = 1;
      this.TestSetType=false;
      this.ExerSetType=false;
      this.getList();
    },
    
    // 删除
    removeShow(){

    },

    // 取消
    closeSub(){
      this.addObj = {
        csid:'',
        level:'',
        name:'',
        num:''
      };
      this.showType = '';
    },

    addShow(){
      var that = this;
      this.showType = 'add';
      
    },

    // 添加题型
    addSub(){
      // this.topicList.push({type:'',num:0});
      var that = this;
      if(this.addObj.name == ''){
        this.$message('请填写名称！');
        return false;
      } else if(this.addObj.csid == ''){
        this.$message('请选择证书类型！');
        return false;
      } else if(this.addObj.level== ''){
        this.$message('请选择证书级别！');
        return false;
      } else if(this.addObj.num == ''){
        this.$message('请选择章节！');
        return false;
      };
      if(this.showType == 'add'){
        this.addObj.type = '1-2-1'
      } else {
        this.addObj.type = '1-2-5'
      }
      saveCert(this.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('添加成功！');
          that.dataList = [];
          that.obj = {
            page:1,
            rows:10,
          };
          that.getList();
          that.closeSub();

        } else {
          that.$message(data.msg);
        }
      })
    },

    topicHide(){
      this.ExerSet={
        cert_id:'',
        name:'',
        img:'',
        chapter:[
          
        ]
      };
      this.TestSet={
        cert_id:'',
        name:'',
        img:'',
        num:'',
        score:'',
        pass:'',
        contime:'',
        topic_set:[
          {type:'',score:'',num:''},
        ],
      };
      this.headID = 1;
      this.TestSetType=false;
      this.ExerSetType=false;
      this.addType = false;
    },

    headSub(e){
      var that = this;
      this.headID = e;
      if(e == 2){
        if(that.TestSetType){
          return false;
        }
        getTestSet({cert_id:this.configID,type:'1-2-4'},that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.TestSet = data.data;
            if(that.TestSet.topic_set == '' || that.TestSet.topic_set == null){
              that.TestSet.topic_set = [
                {type:'',score:'',num:''},
              ]
            };
            that.TestSetType = true;
          } else {
            that.$message(data.message);
          }
        });
      } else {
        if(that.ExerSetType){
          return false;
        }
        getExerSet({cert_id:that.configID,type:'1-2-4'},that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.ExerSet = data.data;
            if(that.ExerSet.chapter.length > 0){
            } else {
              for(var i= 0;i < that.chapterNum;i++){
                that.ExerSet.chapter.push(
                  {
                    name:'',
                    num:(i+1),
                    topic_set:[
                      {type:'',num:''}
                    ]
                  }
                );
              };
            };
            that.ExerSetType = true;
          } else {
            that.$message(data.msg);
          }
        });
      }
    },

    // 查看题库
    lookTopic(e){
      this.$router.push('/topic?id='+ e.id + '&publish_status=' + e.publish_status + '&num=' +e.num);
    },

    // 查看学员
    lookStudent(e){
      this.$router.push('/student?id='+e);
    },

    // 配置
    configShow(e){
      var that = this;
      // this.ExerSet.cert_id = e.id;
      // this.TestSet.cert_id = e.id;
      // for(var i= 0;i < e.num;i++){
      //   this.ExerSet.chapter.push(
      //     {
      //       name:'',
      //       num:(i+1),
      //       topic_set:[
      //         {type:'',num:''}
      //       ]
      //     }
      //   );
      // };
      // this.addType = true;
      this.configID = e.id;
      this.chapterNum = e.num;
      getExerSet({cert_id:this.configID,type:'1-2-4'},that.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.ExerSet = data.data;
          if(that.ExerSet.chapter.length === e.num){
          } else if(that.ExerSet.chapter.length < e.num){
            var length = parseInt((e.num-that.ExerSet.chapter.length));
            for(var i= 0;i < length;i++){
              that.ExerSet.chapter.push(
                {
                  name:'',
                  num:(i+1),
                  topic_set:[
                    {type:'',num:''}
                  ]
                }
              );
            };
          } else if(that.ExerSet.chapter.length > e.num){
            that.ExerSet.chapter = that.ExerSet.chapter.slice(0,e.num)
          }
          that.addType = true;
          that.ExerSetType = true;
        } else {
          that.$message(data.msg);
        }
      });

      getOpenTopicSetList(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.singleTopic=[];
          data.data.forEach(function(item,index){
            if(item.topic_type==1){
              that.singleTopic.push({id:1,title:'单选题'});
            } else if(item.topic_type==2){
              that.singleTopic.push({id:2,title:'多选题'});
            } else if(item.topic_type==3){
              that.singleTopic.push({id:3,title:'判断题'});
            } else if(item.topic_type==4){
              that.singleTopic.push({id:4,title:'案例题'});
            };
          })
        } else {
          that.$message(data.msg);
        }
      })
    },

    editShow(e){
      this.addObj = {
        csid:e.csid,
        level:e.level,
        name:e.name,
        num:e.num,
        id:e.id
      };
      this.showType='edit';
    },

    getList(){
      var that = this;
      getCertList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.dataList.forEach(function(item,index){
            if(item.publish_status == 0){
              item.publish_status = false;
            } else {
              item.publish_status = true;
            }
          });
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
      
    },

    switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        status:e.publish_status==false?0:1,
        type:'1-2-6'
      };
      updateCertStatus(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    topicSub(){
      var that = this;
      if(this.headID == 1){
        if(this.ExerSet.name == '' || this.ExerSet.name == null){
          that.$message('请填写习题名称！');
          return false;
        };
        if(this.ExerSet.img == '' || this.ExerSet.img == null){
          that.$message('请选择习题图片！');
          return false;
        };
        try {
          that.ExerSet.chapter.forEach(function(item,index){
              if(item.name == ''){
                  that.$message('请填写章节'+(index+1)+'的名称！');
                  throw new Error("EndIterative");
              };
              item.topic_set.forEach(function(ele,num){
                if(ele.type == ''){
                  that.$message('请选择章节'+(index+1)+'的题型'+(num+1)+'的类型！');
                  throw new Error("EndIterative");
                };
                if(ele.num == ''){
                  that.$message('请选择章节'+(index+1)+'的题型'+(num+1)+'的数量！');
                  throw new Error("EndIterative");
                };
              });
            })
        } catch(e) {
            if (e.message != "EndIterative") {
                throw e;
            } else {
                return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
            }
        };
        saveExerSet(that.ExerSet,that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            // that.$message('成功!');
            // that.resetSub();
            // that.addType = false;

            that.successType = true;
          } else {
            that.$message(data.msg);
          }
        })
      } else {
        if(this.TestSet.name == '' || this.TestSet.name == null){
          that.$message('请填写模拟卷名称！');
          return false;
        };
        if(this.TestSet.img == '' || this.TestSet.img == null){
          that.$message('请选择模拟卷图片！');
          return false;
        };
        if(this.TestSet.num == '' || this.TestSet.num == null){
          that.$message('请选择模拟卷数量！');
          return false;
        };
        if(this.TestSet.score == '' || this.TestSet.score == null){
          that.$message('请选择模拟卷总分！');
          return false;
        };
        if(this.TestSet.pass == '' || this.TestSet.pass == null){
          that.$message('请选择模拟卷及格分！');
          return false;
        };
        if(this.TestSet.contime == '' || this.TestSet.contime == null){
          that.$message('请选择模拟卷考试时长！');
          return false;
        };
        
        try {
          that.TestSet.topic_set.forEach(function(ele,num){
            if(ele.type == ''){
              that.$message('请选择题型'+(num+1)+'的类型！');
              throw new Error("EndIterative");
            };
            if(ele.num == ''){
              that.$message('请选择题型'+(num+1)+'的数量！');
              throw new Error("EndIterative");
            };
            if(ele.score == ''){
              that.$message('请选择题型'+(num+1)+'的分数！');
              throw new Error("EndIterative");
            };
          });
        } catch(e) {
            if (e.message != "EndIterative") {
                throw e;
            } else {
                return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
            }
        };

        var numList = [];
        that.TestSet.topic_set.forEach(function(ele,num){
          numList.push(parseInt(ele.num)*ele.score);
        });
        const sum = numList.reduce((total, current) => total + current, 0);
        if(this.TestSet.score > sum){
          that.$message('所有题目分数相加小于考试总分');
          return false;
        }
        if(this.TestSet.score < sum){
          that.$message('所有题目分数相加大于考试总分');
          return false;
        };
        saveTestSet(that.TestSet,that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            // that.$message('成功！');
            // that.resetSub();
            // that.addType = false;
            that.successType = true;
          } else {
            that.$message(data.msg);
          }
        });
      }
    },

    successHide(){
      var that = this;
      that.resetSub();
      that.addType = false;
      that.successType = false;
      this.TestSetType=false;
      this.ExerSetType=false;
    },

    addTopic(e,type){
      if(type == 'set'){
        e.topic_set.push({type:'',num:''});
      } else {
        this.TestSet.topic_set.push({type:'',score:'',num:''});
      }
    },

    removeTopic(e,type,i){
      var that = this;
      if(type == 'set'){
        i.topic_set.splice(e,1);
      } else {
        // this.TestSet.topic_set.push({type:'',score:'',num:''});
        that.TestSet.topic_set.splice(i,1);
      }
    },

    checkStringLength(str, minLen, maxLen) {
      var len = str.replace(/[^\x00-\xff]/g,"**").length; // 将非 ASCII 字符转换成两位字节表示
      return (len >= minLen && len <= maxLen);
    },

    

    textLimit(e){
    },

    numChange(type,index,num){
      if(type == 4){
        console.log()
        this.ExerSet.chapter[index].topic_set[num].num = this.ExerSet.chapter[index].topic_set[num].num * 10
      }
      
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 10%;
}

.dataList .listItem p span{
    display: block;
    margin: 5px 0;
}

.dataList .listItem p:nth-of-type(10) span{
  color: #4C7EFB;
}

.dataList .listItem p:nth-of-type(11) span:first-child{
  color: #FF7543;
}

.dataList .listItem p:nth-of-type(11) span:last-child{
  color: #FF5156;
}

.organiza-form form .form-txt{
  font-size: 0; 
  margin-bottom: 20px;
}

.organiza-form form .txt,
.organiza-form form .txt,
.organiza-form form .title{
  display: inline-block;
  vertical-align: top;
}

.organiza-form form .title{
  font-size: 14px;
  line-height: 36px;
  height: 36px;
  width: 120px;
}

.organiza-form form .txt{
  background-color: #F7F9FA;
  border-radius: 6px;
  padding: 0 10px 0 0;
}

.organiza-form form .txt input{
  width: 410px;
  height: 36px;
  line-height: 36px;
  padding: 6px 10px;
  background-color: transparent;
}

.organiza-form form .txt textarea{
  width: 460px;
  height: 150px;
  padding: 6px 10px;
}

.organiza-form form .txt span{
  font-size: 16px;
  color: #9C9EAA;
  height: 36px;
  line-height: 36px;
  display: inline-block;
  vertical-align: top;
  width: 50px;
}

.organiza-form form .form-txt2 .txt span{
  display: block;
  width: 100%;
  text-align: right;
}

.organiza-form form .txt select{
  height: 36px;
  line-height: 36px;
  border: solid 1px #BFC3CD;
  border-radius: 6px;
  padding: 0 10px;
}

.organiza-form form .txt select option{
  padding: 20px 0;
  font-size: 15px;
  height: 40px;
}

.organiza-form form .txt .btn-add{
  height: 36px;
  line-height: 36px;
  display: inline-block;
  vertical-align: top;
  color: #4C7EFB;
  margin-left: 40px;
}

.organiza-form form .txt .img{
  width: 100px;
  height: 100px;
  border-radius: 10px;
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
  position: relative;
  overflow: hidden;
}

.organiza-form form .txt .img img{
  width: 100%;
  height: 100%;
}

.organiza-form form .txt .img .hover{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.6);
}

.organiza-form form .txt .img .hover i{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

.content1 .organiza-txt{
  overflow-y: auto;
  overflow-x: hidden;
}

.content1 .btnBox{
  font-size: 0;
  width: 100%;
  margin-top: 20px;
}

.content1 .chapter-topic .btnBox {
  display: inline-block;
  vertical-align: top;
  width: auto;
  margin: 0 0 0 0;
}

.content1 .chapter-topic .btnBox .btn{
  height: 36px;
  line-height: 36px;
  background-color: transparent;
  color: #4C7EFB;
  font-size: 14px;
  width: 60px;
}

.content1 .btnBox .btn{
  width: 135px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 30px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  background-color: #CBCBCB;
}

.content1 .btnBox .btn-sub{
  background-color: #4C7EFB;
  margin-right: 80px;
}

.content3 .organiza-txt{
  height: auto;
}

.content3 .organiza-form form .title{
  width: auto;
}

.content3 .btnBox .btn{
  width: 135px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 30px;
  font-size: 16px;
  background-color: #4C7EFB;
}

.content4 .dataList .listItem p,
.content4 .organiza-list p{
  width: calc( 100% / 12 );
}

.content4 .organiza-title .btnBox{
  float: left;
  margin-left: 20px;
}

.content4 .organiza-title .btnBox .btn{
  margin-right: 20px;
}

.organiza-form form .txt.chapter{
  padding: 25px 0;
}

.chapter-title input,
.chapter-title p{
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #3d3d3d;
}

/* .chapter-title p{
  width: ;
} */

.organiza-form form .txt .chapter-title input{
  border: solid 1px #BFC3CD;
  background-color: #F7F9FA;
  border-radius: 6px;
  width: 150px;
}

.chapter-topicList{
  display: block;
}

.chapter-title,
.chapter-topic{
  margin-bottom: 15px;
}

.chapter-topic2{
  margin-left: 10px;
}

.chapter-topic2 input,
.chapter-topic1 select,
.chapter-topic2 p,
.chapter-topic1 p,
.chapter-topic2,
.chapter-topic1{
  display: inline-block;
  vertical-align: top;
}

.chapter-topic2 p,
.chapter-topic1 p{
  font-size: 14px;
  color: #3D3D3D;
  height: 36px;
  line-height: 36px;
}

.organiza-form form .txt .chapter-topic2 input,
.chapter-topic1 select{
  width: 95px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #3D3D3D;
  border: solid 1px #BFC3CD;
  border-radius: 6px;
  padding: 0 10px;
}

.content1 .organiza-title p::before{
  display: none;
}

.content1 .organiza-title p{
  margin-right: 20px;
}

.content1 .organiza-title p.select{
  font-size: 20px;
  font-weight: bold;
  border-bottom: solid 5px #4C7EFB;
}

.organiza-form form .txt span.msg-txt{
  display: block;
  font-size: 12px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/certificate/list.vue